/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-24 14:42:25
 */
import React from "react";
import lazyLoad from "@/routers/utils/lazyLoad";
import { LayoutIndex } from "@/routers/constant";
import { RouteObject } from "@/routers/interface";
import AutomatedRules from "@/pages/AutomatedRules/ManageRules/index";
import AutomatedMarket from "@/pages/AutomatedRules/RulesMarket";
import RuleEdit from "@/pages/AutomatedRules/Edit/index";
import Log from "@/pages/AutomatedRules/Log";
import MenuIcon from "@/routers/menu_icon";
import icon from "@/assets/icons/menu/规则.png";

const formRouter: Array<RouteObject> = [
	{
		element: <LayoutIndex />,
		path: "/Automated",
		meta: {
			title: "Automated rules",
		},
		icon: <MenuIcon src={icon}/>,
		children: [
			{
				path: "/Automated/manage",
				// element: lazyLoad(React.lazy(() => import("@/pages/AutomatedRules/ManageRules/index"))),
				element: <AutomatedRules />,
				meta: {
					requiresAuth: true,
					title: "Manage rules",
					key: "Manage"
				}
			},
			{
				path: "/Automated/market",
				// element: lazyLoad(React.lazy(() => import("@/pages/AutomatedRules/RulesMarket/index"))),
				element: <AutomatedMarket />,
				meta: {
					requiresAuth: true,
					title: "Rules market",
					key: "market"
				}
			},
			{
				path: "/Automated/log",
				// element: lazyLoad(React.lazy(() => import("@/pages/AutomatedRules/RulesMarket/index"))),
				element: <Log />,
				meta: {
					requiresAuth: true,
					title: "Action history",
					key: "log"
				}
			},
			{
				path: "/Automated/edit",
				// element: lazyLoad(React.lazy(() => import("@/pages/AutomatedRules/RulesMarket/index"))),
				element: <RuleEdit />,
				meta: {
					hideInMenu: true,
					requiresAuth: true,
					title: "Rule edit",
					key: "market"
				}
			}
		]
	}
];

export default formRouter;
